export enum TextAlign {
  left = 'left',
  right = 'right',
  center = 'center'
}
export enum TextTransform {
  capitalize = 'capitalize',
  uppercase = 'uppercase',
  lowercase = 'lowercase'
}
